webpackJsonp([248023476013587,254668134183387,8317847874090,141632793497324,46179269009834,10801593696943],{

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ImageRightSection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ImageRightSection(_ref) {
	  var artwork = _ref.artwork,
	      buttonText = _ref.buttonText,
	      copy = _ref.copy,
	      link = _ref.link,
	      title = _ref.title;
	
	  return _react2.default.createElement(
	    _grid2.default,
	    { columns: 12, alignItems: 'center' },
	    _react2.default.createElement(
	      _grid.GridItem,
	      { columnSpan: 12, columnSpanM: 6 },
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { maxWidth: 770 },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'l', type: 'margin', position: 'bottom' },
	          artwork
	        )
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'm', type: 'margin', position: 'bottom' },
	        _react2.default.createElement(_HeadingBlock2.default, {
	          maxWidth: 420,
	          justifyContent: 'center',
	          justifyM: 'start',
	          alignContent: 'center',
	          alignM: 'left',
	          title: title,
	          copy: copy
	        })
	      ),
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center', typeM: 'left' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: link },
	          _react2.default.createElement(
	            _button2.default,
	            { shape: 'rounded', kind: 'ghost', size: 'large' },
	            buttonText
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _grid.GridItem,
	      { columnSpan: 12, columnSpanM: 6 },
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { minWidth: 770 },
	        artwork
	      )
	    )
	  );
	}
	
	ImageRightSection.propTypes = {
	  artwork: _propTypes2.default.object,
	  buttonText: _propTypes2.default.string,
	  copy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  link: _propTypes2.default.string,
	  title: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = MarvelEnterprise;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _ImageRightBlock = __webpack_require__(150);
	
	var _ImageRightBlock2 = _interopRequireDefault(_ImageRightBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MarvelEnterprise(_ref) {
	  var buttonText = _ref.buttonText,
	      copy = _ref.copy,
	      image = _ref.image,
	      title = _ref.title;
	
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'm', sizeM: 'xl', type: 'padding', position: 'topBottom' },
	      _react2.default.createElement(_ImageRightBlock2.default, {
	        title: title,
	        artwork: image,
	        buttonText: buttonText,
	        copy: copy,
	        link: '/enterprise'
	      })
	    )
	  );
	}
	
	MarvelEnterprise.propTypes = {
	  image: _propTypes2.default.object,
	  buttonText: _propTypes2.default.string,
	  copy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  title: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = MediaSingleImage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _bind = __webpack_require__(17);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Shape = __webpack_require__(27);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _Diamonds = __webpack_require__(181);
	
	var _Diamonds2 = _interopRequireDefault(_Diamonds);
	
	var _contentModule = __webpack_require__(255);
	
	var _contentModule2 = _interopRequireDefault(_contentModule);
	
	var _generalModule = __webpack_require__(256);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	var _imageModule = __webpack_require__(257);
	
	var _imageModule2 = _interopRequireDefault(_imageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_extends({}, _contentModule2.default, _generalModule2.default, _imageModule2.default));
	
	function MediaSingleImage(_ref) {
	  var alt = _ref.alt,
	      children = _ref.children,
	      copy = _ref.copy,
	      hasShadow = _ref.hasShadow,
	      headingSpacing = _ref.headingSpacing,
	      imageBorderRadius = _ref.imageBorderRadius,
	      justify = _ref.justify,
	      justifyM = _ref.justifyM,
	      maxWidth = _ref.maxWidth,
	      paragraphSize = _ref.paragraphSize,
	      reversed = _ref.reversed,
	      shapes = _ref.shapes,
	      src = _ref.src,
	      title = _ref.title;
	
	  var singleImageClassName = cx('singleImage');
	  var imageClassName = cx('image', {
	    imageReversed: reversed
	  });
	  var contentClassName = cx('content', {
	    contentReversed: reversed
	  });
	
	  var contentProps = {
	    copy: copy,
	    justify: justify,
	    justifyM: justifyM,
	    paragraphSize: paragraphSize,
	    spacing: headingSpacing,
	    title: title
	  };
	
	  var ImageProps = {
	    alt: alt,
	    borderRadius: imageBorderRadius,
	    maxWidth: maxWidth || 1200,
	    src: src
	  };
	
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      'div',
	      { className: singleImageClassName },
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { maxWidth: 770 },
	        src && _react2.default.createElement(
	          _spacing2.default,
	          { size: 'l', type: 'margin', position: 'bottom' },
	          _react2.default.createElement(_Image2.default, _extends({}, ImageProps, { hasShadow: hasShadow }))
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: contentClassName },
	        _react2.default.createElement(
	          _HeadingBlock2.default,
	          contentProps,
	          children
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: imageClassName },
	        shapes && _react2.default.createElement(
	          _reactResponsive2.default,
	          { minWidth: 770 },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_Shape2.default, {
	              width: 300,
	              height: 300,
	              type: 'losange',
	              color: 'yellow',
	              top: '50%',
	              left: '-3%'
	            }),
	            _react2.default.createElement(_Diamonds2.default, { top: '50%', left: '-4%', size: 220 })
	          )
	        ),
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { minWidth: 770 },
	          src && _react2.default.createElement(_Image2.default, _extends({}, ImageProps, { hasShadow: hasShadow }))
	        )
	      )
	    )
	  );
	}
	
	MediaSingleImage.propTypes = {
	  alt: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  copy: _propTypes2.default.string,
	  hasShadow: _propTypes2.default.bool,
	  headingSpacing: _customPropTypesCheck2.default,
	  imageBorderRadius: _propTypes2.default.string,
	  justify: _propTypes2.default.string,
	  justifyM: _propTypes2.default.string,
	  maxWidth: _propTypes2.default.number,
	  paragraphSize: _propTypes2.default.string,
	  reversed: _propTypes2.default.bool,
	  shapes: _propTypes2.default.bool,
	  src: _propTypes2.default.string,
	  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
	};
	
	MediaSingleImage.defaultProps = {
	  hasShadow: true,
	  headingSpacing: 'l',
	  imageBorderRadius: 'l',
	  reversed: false,
	  shapes: false
	};
	module.exports = exports['default'];

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"src-components-modules-Media-MediaSingleImage-style----content-module---content---h7dJy breakPointM-width-40 breakPointM-position-absolute height-100 position-static width-100","contentReversed":"src-components-modules-Media-MediaSingleImage-style----content-module---contentReversed---3tN5l"};

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"singleImage":"src-components-modules-Media-MediaSingleImage-style----general-module---singleImage---BWXmW position-relative"};

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image":"src-components-modules-Media-MediaSingleImage-style----image-module---image---iRly0","imageReversed":"src-components-modules-Media-MediaSingleImage-style----image-module---imageReversed---1InNH"};

/***/ }),

/***/ 2715:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/marvelEnterprise@2x-c1b017aa8e9b58ae0eedbd3b9d1adeab.jpg";

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Automated;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _HandoffArtwork = __webpack_require__(464);
	
	var _HandoffArtwork2 = _interopRequireDefault(_HandoffArtwork);
	
	var _ImageRightBlock = __webpack_require__(150);
	
	var _ImageRightBlock2 = _interopRequireDefault(_ImageRightBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Automated() {
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'm', sizeM: 'xl', type: 'padding', position: 'topBottom' },
	      _react2.default.createElement(_ImageRightBlock2.default, {
	        title: 'Design specs, automated',
	        artwork: _react2.default.createElement(_HandoffArtwork2.default, null),
	        buttonText: 'Learn more',
	        copy: _react2.default.createElement(
	          'span',
	          null,
	          'Optimise your design-to-development process with our Handoff tool.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'With one click you can instantly download assets and generate CSS, Swift and Android XML code for your prototypes, which stays in sync with your most recent design changes.'
	        ),
	        link: '/features/handoff'
	      })
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Collaboration;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _CollaborationArtwork = __webpack_require__(463);
	
	var _CollaborationArtwork2 = _interopRequireDefault(_CollaborationArtwork);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Collaboration() {
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      _grid2.default,
	      { columns: 12, alignItems: 'center' },
	      _react2.default.createElement(
	        _grid.GridItem,
	        { columnSpan: 12, columnSpanM: 6 },
	        _react2.default.createElement(_CollaborationArtwork2.default, { color: 'lightOrange', patternColor: 'orange' })
	      ),
	      _react2.default.createElement(
	        _grid.GridItem,
	        { columnSpan: 12, columnSpanM: 6 },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'l', sizeM: '0', type: 'margin', position: 'bottom' },
	          _react2.default.createElement(
	            _HeadingBlock2.default,
	            {
	              size: 's',
	              spacing: 'm',
	              justifyM: 'center',
	              title: 'Cross company collaboration, solved',
	              copy: _react2.default.createElement(
	                'span',
	                null,
	                'Marvel becomes a central space for all of your design needs and brings your teams together through our collaboration features.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                'Give your team and stakeholders full visibility across every project, add unique teams, create folders and leave design feedback as comments and annotations.'
	              )
	            },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/features/collaboration' },
	              _react2.default.createElement(
	                _button2.default,
	                { shape: 'rounded', size: 'large', kind: 'ghost' },
	                'Learn more'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Creativity;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _MediaSingleImage = __webpack_require__(207);
	
	var _MediaSingleImage2 = _interopRequireDefault(_MediaSingleImage);
	
	var _assets = __webpack_require__(153);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Creativity() {
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'l', sizeM: 'xl', type: 'padding', position: 'topBottom' },
	      _react2.default.createElement(
	        _MediaSingleImage2.default,
	        _extends({}, _assets2.default.browser, {
	          copy: _react2.default.createElement(
	            'span',
	            null,
	            'Create beautiful wireframes, mockups, website or app prototypes for any device right from your browser.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Sync designs from Sketch, upload your images or build mockups directly within our design tool where you\'ll find millions of assets, stock photos and icons at your fingertips.'
	          ),
	          headingSpacing: 'm',
	          shapes: true,
	          title: 'Design anything, anywhere.'
	        }),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/features/design' },
	          _react2.default.createElement(
	            _button2.default,
	            { shape: 'rounded', kind: 'ghost', size: 'large' },
	            'Learn more'
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = FooterCta;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CtaDefault = __webpack_require__(61);
	
	var _CtaDefault2 = _interopRequireDefault(_CtaDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FooterCta() {
	  var buttons = [{
	    link: '/enterprise',
	    text: 'Discover Marvel Enterprise',
	    styles: { shape: 'rounded', size: 'large', minWidth: 230 }
	  }];
	  return _react2.default.createElement(_CtaDefault2.default, {
	    maxWidth: 660,
	    title: 'Work in a large team? Find out more about Marvel Enterprise.',
	    buttons: buttons
	  });
	}
	module.exports = exports['default'];

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Interactive;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _MediaMultipleImages = __webpack_require__(30);
	
	var _MediaMultipleImages2 = _interopRequireDefault(_MediaMultipleImages);
	
	var _ParallaxWrapper = __webpack_require__(28);
	
	var _ParallaxWrapper2 = _interopRequireDefault(_ParallaxWrapper);
	
	var _assets = __webpack_require__(153);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Interactive() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'shape bg-orange--l' },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { size: 'l' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'xl', type: 'padding', position: 'topBottom' },
	        _react2.default.createElement(
	          _grid2.default,
	          { columns: 12, alignItems: 'center' },
	          _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 12, columnSpanM: 7 },
	            _react2.default.createElement(
	              _MediaMultipleImages2.default,
	              {
	                fallbackImageAlt: 'Interactive prototypes will reinvent how you showcase design work',
	                fallbackImageMaxWidth: 686,
	                fallbackImageSrc: _assets2.default.interactive.src
	              },
	              _react2.default.createElement(
	                _ParallaxWrapper2.default,
	                { speed: 1.6 },
	                _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.pattern, {
	                  hasShadow: false,
	                  maxWidth: 380,
	                  position: 'absolute',
	                  top: 'auto',
	                  left: 'auto',
	                  right: '20%',
	                  bottom: '10%'
	                }))
	              ),
	              _react2.default.createElement(
	                _ParallaxWrapper2.default,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'opacity-50' },
	                  _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.people, {
	                    borderRadius: 'm',
	                    left: '6%',
	                    maxWidth: 380,
	                    position: 'absolute',
	                    top: '20%'
	                  }))
	                )
	              ),
	              _react2.default.createElement(
	                _ParallaxWrapper2.default,
	                { speed: 1.6 },
	                _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.photos, {
	                  borderRadius: 'm',
	                  left: '21%',
	                  maxWidth: 380,
	                  position: 'absolute',
	                  top: '36%'
	                }))
	              ),
	              _react2.default.createElement(
	                _ParallaxWrapper2.default,
	                { speed: 2 },
	                _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.buttons, {
	                  borderRadius: 'm',
	                  hasShadow: false,
	                  maxWidth: 210,
	                  position: 'absolute',
	                  top: '62%'
	                }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 12, columnSpanM: 5 },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 'm', type: 'margin', position: 'bottom' },
	              _react2.default.createElement(_HeadingBlock2.default, {
	                color: 'white',
	                justifyContent: 'center',
	                justifyM: 'start',
	                maxWidth: 460,
	                title: 'Reinvent how you present design work',
	                copy: _react2.default.createElement(
	                  'span',
	                  null,
	                  'The days of static designs, slide decks and email attachments to present work are over. Transform how you share work by showcasing interactive Marvel prototypes.',
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  'User journeys and site hierarchy can be difficult to explain, Marvel takes the complexity out of it by showing your audience realistic interactions. With no coding required, we make design simple, for everyone.'
	                )
	              })
	            ),
	            _react2.default.createElement(
	              _align2.default,
	              { type: 'center', typeM: 'left' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/features/prototyping' },
	                _react2.default.createElement(
	                  _button2.default,
	                  {
	                    background: 'white',
	                    hover: 'blue',
	                    color: 'slate',
	                    shape: 'rounded',
	                    size: 'large'
	                  },
	                  'Learn more'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1312:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = WhyMarvel;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _MarvelEnterprise = __webpack_require__(594);
	
	var _MarvelEnterprise2 = _interopRequireDefault(_MarvelEnterprise);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _IntegrationsCta = __webpack_require__(118);
	
	var _IntegrationsCta2 = _interopRequireDefault(_IntegrationsCta);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Whitespace = __webpack_require__(35);
	
	var _Whitespace2 = _interopRequireDefault(_Whitespace);
	
	var _marvelEnterprise2x = __webpack_require__(2715);
	
	var _marvelEnterprise2x2 = _interopRequireDefault(_marvelEnterprise2x);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _Automated = __webpack_require__(689);
	
	var _Automated2 = _interopRequireDefault(_Automated);
	
	var _Collaboration = __webpack_require__(690);
	
	var _Collaboration2 = _interopRequireDefault(_Collaboration);
	
	var _Creativity = __webpack_require__(691);
	
	var _Creativity2 = _interopRequireDefault(_Creativity);
	
	var _Interactive = __webpack_require__(693);
	
	var _Interactive2 = _interopRequireDefault(_Interactive);
	
	var _FooterCta = __webpack_require__(692);
	
	var _FooterCta2 = _interopRequireDefault(_FooterCta);
	
	var _generalModule = __webpack_require__(1508);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function WhyMarvel() {
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: _metadata2.default['why-marvel'].title,
	      meta: [{
	        name: 'description',
	        content: _metadata2.default['why-marvel'].description
	      }],
	      header: true,
	      footer: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'overflow-hidden' },
	      _react2.default.createElement(
	        'div',
	        { className: _generalModule2.default.wrap },
	        _react2.default.createElement(
	          'h1',
	          { className: _generalModule2.default.heading },
	          'Everything you need to bring ideas to life'
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'l', type: 'padding', position: 'bottom' },
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 720 },
	            _react2.default.createElement(
	              'h2',
	              { className: _generalModule2.default.subheading },
	              'With the Marvel design platform, access all the core functionality you need to build digital products - wireframe, prototype and generate design specs in one place.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _generalModule2.default.buttons },
	          _react2.default.createElement(
	            'div',
	            { className: _generalModule2.default.margin },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/signup/' },
	              _react2.default.createElement(
	                _button2.default,
	                { size: 'large', shape: 'rounded', minWidth: 170 },
	                'Sign up free'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/pricing/' },
	              _react2.default.createElement(
	                _button2.default,
	                {
	                  size: 'large',
	                  kind: 'ghost',
	                  shape: 'rounded',
	                  minWidth: 170
	                },
	                'Explore Plans'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Creativity2.default, null),
	      _react2.default.createElement(_Interactive2.default, null),
	      _react2.default.createElement(_Whitespace2.default, { size: 'l' }),
	      _react2.default.createElement(_Automated2.default, null),
	      _react2.default.createElement(_Whitespace2.default, { size: 'xl' }),
	      _react2.default.createElement(_Collaboration2.default, null),
	      _react2.default.createElement(_MarvelEnterprise2.default, {
	        buttonText: 'Learn more',
	        copy: _react2.default.createElement(
	          'span',
	          null,
	          'Each stage of the design process unified in one platform - where you and your team, no matter the size can wireframe, prototype, user test and handoff to developers collaboratively.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'Marvel Enterprise 3 has been built on blazing fast technology with features that focus on helping large teams make design more productive.'
	        ),
	        image: _react2.default.createElement(_Image2.default, {
	          alt: 'Marvel Enterprise Dashboard and UserTesting Dashboard',
	          hasShadow: false,
	          maxWidth: 700,
	          src: _marvelEnterprise2x2.default
	        }),
	        title: 'Design, test and scale, together'
	      }),
	      _react2.default.createElement(_IntegrationsCta2.default, null),
	      _react2.default.createElement(_FooterCta2.default, null)
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1508:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrap":"src-pages-why-marvel-style----general-module---wrap---3Mc4- pageWrap c-black textAlign-center pageWrap-l","heading":"src-pages-why-marvel-style----general-module---heading---2CykA fontWeight-5 marginBottom-m fontSize-xxxl lineHeight-title breakPointS-fontSize-xxxxl","subheading":"src-pages-why-marvel-style----general-module---subheading---D2BeF fontSize-l lineHeight-copy breakPointS-fontSize-xl breakPointM-fontSize-xxl breakPointM-lineHeight-xxl fontWeight-4 c-slate","buttons":"src-pages-why-marvel-style----general-module---buttons---DCmCT breakPointS-inline","margin":"src-pages-why-marvel-style----general-module---margin---3rZXq marginBottom-m breakPointS-marginBottom-0 breakPointS-marginRight-m"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-why-marvel-index-js-0de1c9e0df84fd0b6876.js